import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { useAtomValue, useSetAtom } from 'jotai';
import { type FC } from 'react';

import { DRAWER_TITLE_ID, DrawerBody, DrawerHeader, IconButton, Text } from '@growtherapy/sprout-ui';

import {
  TreatmentPlansContentConnected,
  TreatmentPlansContentConnectedProps,
} from '@grow-therapy-team/seedling-components';

import { ProviderDrawerState, drawerStateAtom, selectedClientInfoAtom } from '../../state';

export const TreatmentPlansContentDrawer = ({
  onClickBackButton,
  patientShortId,
  treatmentPlansContentComponent: TreatmentPlansContent,
}: {
  onClickBackButton: () => void;
  patientShortId: string;
  treatmentPlansContentComponent: FC<TreatmentPlansContentConnectedProps>;
}) => {
  return (
    <>
      <DrawerHeader>
        <div className='flex items-center' data-testid='treatment-plans.header'>
          {onClickBackButton && (
            <IconButton
              onClick={onClickBackButton}
              className='mr-4 w-8 h-8 flex justify-center items-center'
              size='sm'
              aria-label='Go back'
              data-testid='treatment-plans.button.back'
              iconDefinition={faArrowLeft}
            />
          )}
          <Text variant='lg' className='font-medium' id={DRAWER_TITLE_ID}>
            Treatment Plans
          </Text>
        </div>
      </DrawerHeader>
      <DrawerBody>
        <div data-testid='client-info.treatment.treatment-plans-content'>
          <TreatmentPlansContent patientShortId={patientShortId} />
        </div>
      </DrawerBody>
    </>
  );
};

export const TreatmentPlansContentDrawerWrapper = () => {
  const setDrawerState = useSetAtom(drawerStateAtom);

  const onClickBackButton = () => {
    setDrawerState(ProviderDrawerState.CLIENT_INFORMATION);
  };

  const patientShortId = useAtomValue(selectedClientInfoAtom)?.patientShortId ?? '';

  return (
    <TreatmentPlansContentDrawer
      onClickBackButton={onClickBackButton}
      patientShortId={patientShortId}
      treatmentPlansContentComponent={TreatmentPlansContentConnected}
    />
  );
};
